import { render, staticRenderFns } from "./Incidences.vue?vue&type=template&id=cb79dae6&scoped=true"
import script from "./Incidences.vue?vue&type=script&lang=js"
export * from "./Incidences.vue?vue&type=script&lang=js"
import style0 from "./Incidences.vue?vue&type=style&index=0&id=cb79dae6&prod&lang=scss&scoped=true"
import style1 from "./Incidences.vue?vue&type=style&index=1&id=cb79dae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb79dae6",
  null
  
)

export default component.exports